import { IHBReqEvent, XHubbleAccessData } from "src/types/type";
import timingMath from "./timing-math";
import ymcHeaderDecode from "./ymc-header-decode";
const undfd = undefined;
function responseHeaders(resHeaders: string): Map<string, unknown> {
  const map = new Map<string, unknown>();
  const arr = String(resHeaders).split(/\r?\n/);

  arr.forEach(item => {
    const match = item.match(/^([^:]+):\s*(.*)$/);
    if(match) {
      map.set(match[1], match[2]);
    }
  });
  return map;
}

// 获取响应相关采集数据
export default function getResponseData(reqEvent: IHBReqEvent) {
  const resHeaders = reqEvent._resHeaders;
  const rtiming = reqEvent.rtiming as PerformanceResourceTiming;
  const timeMap = timingMath(rtiming);
  let headerMap = null;
  if(resHeaders && resHeaders.toString() === '[object Headers]') {
    headerMap = resHeaders;
  } else if(typeof resHeaders === 'string') {
    headerMap = responseHeaders(reqEvent._resHeaders as string);
  } else {
    return {};
  }

  const xYmc: XHubbleAccessData = (() => {
    let ret = null;
    let ymcData = headerMap.get('x-ymc-access-data') as string;
    if (ymcData) {
      ret = ymcHeaderDecode(ymcData);
      if (!ret) {
        hbLogger.warn('x-ymc-access-data 解析异常', reqEvent.rurl, ymcData);
      }
    }
    return ret;
  })();

  // _relativeTimeStart和_relativeTimeEnd为相对时间，是拿performance.now()设置的值
  // https://developer.mozilla.org/zh-CN/docs/Web/API/Performance/now
  // 相对时间存在时，拿相对时间计算耗时，可以摆脱客户端时间的影响，避免因客户端修改时间而出现的异常数据问题
  const es = timeMap?.es || (reqEvent._relativeTimeStart ?
    Math.round(reqEvent._relativeTimeEnd - reqEvent._relativeTimeStart) :
    Math.round(reqEvent.txre - reqEvent.txrs)) || undfd;
  const contentType = (headerMap.get('content-type') || '') as string;
  const contentLen = headerMap.get('content-length');
  // 以下响应头字段获取不到，都属于自定义header头，浏览器安全限制默认前端无法读取到的，
  // 必须服务配置Access-Control-Expose-Headers，允许读取这些头信息才可以
  const crid = (() => {
    let val = [];
    ['EagleId', 'Eo-Log-Uuid', 'X-NWS-LOG-UUID', 'X-Ccdn-Req-Id-46b1', 'Via', 'X-Cache', 'X-HW-Cache', 'X-Cache-Lookup'].forEach(key => {
      const kv = headerMap.get(key.toLowerCase());
      if(kv) {
        val.push(`${key}:${kv}`);
      }
    });
    return val.join(';');
  })();
  const ret = {
    restype: contentType.replace(/\;.*$/, ''),
    es,
    tcd: timeMap.tcd,
    crid,
    // 返回结果长度、请求参数长度暂不处理
    res: rtiming?.encodedBodySize || contentLen,
  } as HBEventData<HBRequestInfo>;

  if(xYmc) {
    const srt = Math.round(Number(xYmc.request_time) * 1000) || undfd;
    const tnt = Math.max(Math.round((timeMap?.tnt || es) - srt), 0) || undfd;
    Object.assign(ret, {
      ign: xYmc.ingress_name,
      ns: xYmc.namespace,
      traceid: xYmc.traceId,
      req: xYmc.request_length,
      uar: xYmc.upstream_addr,
      srt,
      tnt,
    });
  }

  return ret;
}
